<h1 matDialogTitle
    translate>
    {{ isClone ? 'transactions_clone_modal_title' : 'transactions_edit_modal_title' }}
</h1>

<form [formGroup]="transactionForm"
      (submit)="onSubmit()"
      uiPreventAutofill>

    <mat-dialog-content class="mat-typography">
        <div>
            <mat-form-field>
                <input [formControlName]="TransactionFormControl.reference"
                       [readonly]="!isClone"
                       [placeholder]="'transaction_edit_modal_reference_field' | translate"
                       matInput
                       data-cy="transaction-upsert-modal-reference-field" />
            </mat-form-field>
        </div>
        <div>
            <mat-form-field>
                <ui-suggest [formControlName]="TransactionFormControl.priority"
                            [items]="priorityTypes"
                            [placeholder]="'transaction_edit_modal_priority_field' | translate"
                            [clearable]="false"
                            [disabled]="isSlaEnabled"
                            data-cy="transaction-upsert-modal-priority-field"
                            required>
                </ui-suggest>
            </mat-form-field>
        </div>
        <div data-cy="transaction-upsert-modal-defer-date-container">
            <ui-datetime-picker [formControlName]="TransactionFormControl.deferDate"
                                [datePlaceholder]="'transaction_edit_modal_defer_picker_date' | translate"
                                [timePlaceholder]="'transaction_edit_modal_defer_picker_time' | translate">
            </ui-datetime-picker>
        </div>
        <div data-cy="transaction-upsert-modal-due-date-container">
            <ui-datetime-picker [formControlName]="TransactionFormControl.dueDate"
                                [datePlaceholder]="'transaction_edit_modal_due_picker_date' | translate"
                                [timePlaceholder]="'transaction_edit_modal_due_picker_time' | translate">
            </ui-datetime-picker>
        </div>
        <ui-json-formatter [data]="transactionForm.get(TransactionFormControl.specificContent)!.value"
                           [levelsOpen]="1"
                           [key]="'transaction_edit_modal_specific_data' | translate"
                           [objectPlaceholder]="'global_json_object_placeholder' | translate"
                           [emptyPlaceholder]="'global_json_empty_placeholder' | translate"
                           data-cy="transaction-upsert-modal-specific-content">
        </ui-json-formatter>
        <div class="buttons-container">
            <div class="button-container">
                <a [matTooltip]="'transaction_edit_modal_specific_data_download' | translate"
                   [href]="downloadLink"
                   (click)="downloadItemData($event)"
                   data-cy="transaction-upsert-modal-download"
                   mat-stroked-button
                   target="_blank">
                    <mat-icon>file_download</mat-icon>
                    {{ 'transaction_edit_modal_specific_data_download' | translate }}
                </a>
            </div>
            <div [fileBrowseRef]="browseTrigger._getHostElement()"
                 [multiple]="false"
                 [disabled]="isFileUploading$ | async"
                 (fileChange)="specificDataChanged($event)"
                 uiDragAndDropFile
                 fileType=".json"
                 class="button-container">
                <button #browseTrigger
                        [disabled]="isFileUploading$ | async"
                        [spinnerButtonLoading]="isFileUploading$ | async"
                        [matTooltip]="'transaction_edit_modal_specific_data_upload' | translate"
                        data-cy="transaction-upsert-modal-upload"
                        ui-spinner-button
                        mat-stroked-button
                        type="button">
                    <mat-icon>file_upload</mat-icon>
                    {{ 'transaction_edit_modal_specific_data_upload' | translate }}
                </button>
            </div>
        </div>
        <mat-form-field *ngIf="!isClone">
            <ui-toggle-switch [placeholder]="'transaction_edit_modal_transaction_progress' | translate"
                              [onString]="'transaction_edit_modal_keep_transaction_progress' | translate"
                              [offString]="'transaction_edit_modal_reset_transaction_progress' | translate"
                              [formControlName]="TransactionFormControl.keepProgress"
                              data-cy="transaction-upsert-modal-check-progress-action">
            </ui-toggle-switch>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-dialog-close
                mat-button
                type="button">
            {{ 'modal_action_close' | translate }}
        </button>
        <button [spinnerButtonLoading]="submitting$ | async"
                [disabled]="isSubmitDisabled"
                type="submit"
                mat-flat-button
                ui-spinner-button
                color="primary"
                data-cy="transaction-upsert-modal-submit">
            {{ (isClone ? 'transaction_edit_modal_create_item' : 'transaction_edit_modal_save') | translate }}
        </button>
    </mat-dialog-actions>
</form>
